import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ErrorBoundary = ({
  isError,
  children,
}: {
  isError: boolean;
  children: React.ReactNode;
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  return isError ? (
    <main className="element-center flex-col h-screen container">
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/error.svg`}
        width={344}
        height={260}
        alt="error-occurred"
        className="object-contain mb-4x"
      />
      <h3 className="text-title_2 text-black font-[600]">{t('errorTitle')}</h3>
      <p className="text-body_1 text-black font-[400] mb-2x">
        {t('errorDescription')}
      </p>
      <div className="flex items-center gap-2x flex-col md:flex-row">
        <Link
          to={location.href}
          onClick={() => typeof window !== 'undefined' && location.reload()}
          className="h-[48px] w-[163px] bg-blue rounded-[26px] element-center"
        >
          <span className="text-link text-white">{t('reload')}</span>
        </Link>
        <Link
          to={`${process.env.REACT_APP_BASE_URL}/${locale}/feedback`}
          className="h-[48px] w-[163px] bg-gray_light_1 rounded-[26px] font-[700] element-center text-blue"
        >
          {t('ReportProblem')}
        </Link>
      </div>
    </main>
  ) : (
    <>{children}</>
  );
};

export default ErrorBoundary;
